var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommunicationChallenges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.5V17.5C14 17.7652 13.8946 18.0196 13.7071 18.2071C13.5196 18.3946 13.2652 18.5 13 18.5H6L3 21.5V11.5C3 11.2348 3.10536 10.9804 3.29289 10.7929C3.48043 10.6054 3.73478 10.5 4 10.5H6M21 14.5L18 11.5H11C10.7348 11.5 10.4804 11.3946 10.2929 11.2071C10.1054 11.0196 10 10.7652 10 10.5V4.5C10 4.23478 10.1054 3.98043 10.2929 3.79289C10.4804 3.60536 10.7348 3.5 11 3.5H20C20.2652 3.5 20.5196 3.60536 20.7071 3.79289C20.8946 3.98043 21 4.23478 21 4.5V14.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunicationChallenges);
export default __webpack_public_path__ + "static/media/communication_challenges.69728789cb29537553dfa7f9a4fb3208.svg";
export { ForwardRef as ReactComponent };